import 'css-chunksrc/client/scenes/planzoneResourceGroupCreation/groupCreationForm/resourcesList/addMember/styles.scss';export default {
  "icon": "_icon_9rdd7_1",
  "list": "_list_9rdd7_7"
};